// const CART = [
//   {
//     quantity: 1,
//     price: 20
//     ...
//   },
//   {
//     quantity: 3,
//     price: 10
//     ...
//   },
//   {
//     quantity: 10,
//     price: 4
//     ...
//   }
//  ...
// ];

// currency:{
//   name: 'EUR',
//   rate: 1,
//   symbol: '€'
// }

import moment from "moment";

export function calculateValueCurrency(value, currency) {
  let priceCurrency = value;
  if (currency && currency.rate) {
    priceCurrency = priceCurrency * currency.rate;
  }
  return priceCurrency;
}

export function calculateCartNumber(cart) {
  const reducer = (accumulator, currentValue) => {
    if (!Number.isNaN(currentValue.quantity)) {
      return accumulator + currentValue.quantity;
    }
    return accumulator;
  };

  return cart.reduce(reducer, 0);
}

export function priceTotal(cart, currency) {
  // console.log("PRECE TOTAL CALL", { cart, currency, maxIngredientsSelect });

  // TODO CHECK NOT WORK IF THE USER SELECT A NUMBER LESS THAN MAX INGREDIENTS
  // WORK FINE OTHERWISE
  const reducer = (accumulator, currentValue) => {
    if (
      !Number.isNaN(currentValue.price) &&
      !Number.isNaN(currentValue.quantity)
    ) {
      let totalPrice = currentValue.price;
      if (currentValue && currentValue.ingredientC) {
        Object.keys(currentValue.ingredientC).forEach(e => {
          const [, id] = e.split("_");

          let number = 0;

          let maxNumber = 0;

          if (currentValue && currentValue.add) {
            // CERCO SE PER QUELLA AGGIUNTA CI SONO DELLE QUANTITÀ GRATIS
            // SE LE TROVO LE IMPOSTO SUL NUMERO MAX NUMBER
            /* ************************************
            THIS CHECK IS USED IN ADD INGREDIENTS
            ************************************** */
            const findEl = currentValue.add.find(el => el._id === id);

            maxNumber = findEl && findEl.maxNumber ? findEl.maxNumber : 0;
          }

          if (currentValue && currentValue.maxObj) {
            /* ***********************************
            THIS CHECK IS USED IN THE CART
            ************************************* */
            maxNumber =
              currentValue.maxObj && currentValue.maxObj[id]
                ? currentValue.maxObj[id]
                : 0;
          }

          // UTILIZZO IL SORT PER OFFRIRE GRATIS GLI ELEMENTI CON UN COSTO MINORE
          // NEL CASO IN CUI VENGA SUPERATA LA QUANTITÀ DI INGREDIENTI GRATIS
          const ingredientSort = currentValue.ingredientC[e].sort((c, d) => {
            const f = c && c.price ? Number(c.price.replace(",", ".")) : 0.00;
            const g = d && d.price ? Number(d.price.replace(",", ".")) : 0.00;
            return f - g;
          });

          ingredientSort.forEach(item => {
            const price =
              item.price &&
              Number(item.price.replace(",", ".")) &&
              !Number.isNaN(item.price.replace(",", "."))
                ? Number(item.price.replace(",", "."))
                : 0;
            number += item.quantity;
            if (number > maxNumber) {
              let multiplierQ = number - maxNumber;
              totalPrice +=
                price *
                (multiplierQ > item.quantity ? item.quantity : multiplierQ);
            } else {
              // NON DEVO AGGIORNARE IL PREZZO PERCHÈ L'ARTICOLO è ANCORA GRATUITO
            }
            // promotionCost = maxNumber && price ? price : 0;
            // totalPrice += price * item.quantity;
          });

          // if (promotionCost) {
          //   // console.log("promotionCost", {
          //   //   number,
          //   //   promotionCost,
          //   //   max: maxIngredientsSelect[id]
          //   // });
          //   if (number >= maxNumber) {
          //     totalPrice -= promotionCost * maxNumber;
          //   } else {
          //     totalPrice -= promotionCost * number;
          //   }
          // }
        });
      }
      // console.log("AHAHAH", {
      //   accumulator,
      //   totalPrice,
      //   cart,
      //   hg: currentValue.hg
      // });
      const pricePerHg = currentValue.price;
      const hg = currentValue.hg ? currentValue.hg / 100 : 1;

      return (
        accumulator +
        hg * pricePerHg * currentValue.quantity +
        (totalPrice - pricePerHg) * currentValue.quantity
      );
    }
    return accumulator;
  };

  const priceOnEuro = cart.reduce(reducer, 0);
  return calculateValueCurrency(priceOnEuro, currency);
}

export function calculateDiscount(promotionalCode, totalPrice, currency) {
  /* NON USATA ATTUALMENTE - NON ESISTE UNO SCONTO GLOBALE */
  let discount = 0;
  if (promotionalCode && promotionalCode.active && totalPrice) {
    // CONTROLLO CHE è STATA RAGGIUNTA LA SOMMA MINIMA PER APPLICARE LO SCONTO
    const currencyMinCost = calculateValueCurrency(
      promotionalCode.minCost,
      currency
    );
    if (totalPrice >= currencyMinCost) {
      // CONTROLLO CHE LO SCONTO è ANCORA VALIDO
      let isStillValid = false;
      if (promotionalCode.timeLimitEnabled) {
        const now = moment();
        const toDate = moment(promotionalCode.to);
        const fromDate = moment(promotionalCode.from);
        if (now.isBefore(toDate) && now.isAfter(fromDate)) {
          // IL CODICE è ANCORA VALIDO ED è ATTIVO ED è STATA RAGGIUNTA LA SOMMA MINIMA
          isStillValid = true;
        }
      } else {
        isStillValid = true;
      }
      if (isStillValid) {
        if (promotionalCode.measure === "percentage") {
          // LO SCONTO è IN PERCENTUALE
          discount = (totalPrice * (promotionalCode.value || 0)) / 100;
        } else if (promotionalCode.measure === "euro") {
          // LO SCONTO è IN EURO
          discount = calculateValueCurrency(
            promotionalCode.value || 0,
            currency
          );
        }
      }
    }
  }
  return discount;
}

export function calculateDiscountCategory(promotionalCode, currency, cart) {
  let discount = 0;
  // FILTRO GLI ARTICOLI SOLO PER LA CATEGORIA CON CUI HO LO SCONTO
  if (promotionalCode) {
    // CALCOLO IL COSTO TOTALE DEGLI ARTICOLI A QUI POSSO APPLICARE LO SCONTO
    // const cartCat = cart.filter(el => {
    //   return el.categoria_articolo === promotionalCode.categorie[0].id;
    // });
    const totalPriceCat = priceTotal(cart, currency);
    // APPLICO LO SCONTO SOLO AL COSTTO TOTALE PER QUELLA CATEGORIA
    // LO SCONTO è IN PERCENTUALE
    const discountCat = (totalPriceCat * (promotionalCode.sconto || 0)) / 100;
    // TODO APPLICARE IL CAMBIO DI VALUTA
    discount = discountCat || 0;
  }

  return discount;
}

export function validateDiscount(promotionalCode, totalPrice, currency) {
  let error = null;
  /* ****************************
   QUESTE SONO OPERAZIONI FUTURE NEL CASO IL CODICE AVRÀ UN ORDINE MINIMO
   O/E UN TEMPO LIMITATO DI UTILIZZO
   **************************** */
  if (promotionalCode && promotionalCode.active && totalPrice) {
    // CONTROLLO CHE è STATA RAGGIUNTA LA SOMMA MINIMA PER APPLICARE LO SCONTO
    const currencyMinCost = calculateValueCurrency(
      promotionalCode.minCost,
      currency
    );
    if (promotionalCode.timeLimitEnabled) {
      const now = moment();
      const toDate = moment(promotionalCode.to);
      const fromDate = moment(promotionalCode.from);
      if (now.isBefore(toDate) && now.isAfter(fromDate)) {
        // IL CODICE è ANCORA VALIDO ED è ATTIVO ED è STATA RAGGIUNTA LA SOMMA MINIMA
        if (totalPrice <= currencyMinCost) {
          // CONTROLLO CHE LO SCONTO è ANCORA VALIDO
          error = "NO_MIN_COST";
        }
      } else {
        error = "NO_TIME_VALID";
      }
    } else {
      if (totalPrice <= currencyMinCost) {
        // CONTROLLO CHE LO SCONTO è ANCORA VALIDO
        error = "NO_MIN_COST";
      }
    }
  } else {
    error = "NO_ACTIVE";
  }
  return error;
}

export function calculateAllCart(
  cart,
  currency,
  delivery,
  shippingInfo,
  promotionalCode
) {
  const totalPrice = priceTotal(cart, currency);

  const discountCat = calculateDiscountCategory(
    promotionalCode,
    currency,
    cart
  );

  let deliveryCost =
    delivery && delivery.deliveryPrice && shippingInfo.type !== "take-away"
      ? calculateValueCurrency(Number(delivery.deliveryPrice), currency)
      : 0;
  let servicesFees =
    delivery && delivery.servicePrice
      ? calculateValueCurrency(Number(delivery.servicePrice), currency)
      : 0;

  const cartCounter = calculateCartNumber(cart);

  const total = totalPrice + deliveryCost + servicesFees - discountCat;

  // VAT IS USUALLY 10% on ITALY
  const vat = (total * 10) / 100;

  /* *********************************
   EURO CALCULATION FOR PAYMENT
   ********************************* */

  const currencyEuro = {
    name: "EUR",
    rate: 1,
    symbol: "€"
  };

  const totalPriceEuro = priceTotal(cart, currencyEuro);

  const discountEuro = calculateDiscountCategory(
    promotionalCode,
    currencyEuro,
    cart
  );

  let deliveryCostEuro =
    delivery && delivery.deliveryPrice && shippingInfo.type !== "take-away"
      ? calculateValueCurrency(Number(delivery.deliveryPrice), currencyEuro)
      : 0;
  let servicesFeesEuro =
    delivery && delivery.servicePrice
      ? calculateValueCurrency(Number(delivery.servicePrice), currencyEuro)
      : 0;

  const totalEuro =
    totalPriceEuro + deliveryCostEuro + servicesFeesEuro - discountEuro;

  // VAT IS USUALLY 10% on ITALY
  const vatEuro = (totalEuro * 10) / 100;

  return {
    totalPrice,
    deliveryCost,
    servicesFees,
    total,
    cartCounter,
    totToShow: totalPrice === 0 ? 0 : total,
    vat,
    discount: discountCat,
    // EURO CALCULATION FOR PAYMENT
    totalPriceEuro,
    servicesFeesEuro,
    deliveryCostEuro,
    totalEuro,
    totToShowEuro: totalPriceEuro === 0 ? 0 : totalEuro,
    vatEuro,
    discountEuro
  };
}
